<script lang="ts">

    import { storeIsOpenBurger, storeDomain, storeAnchorToLight, storeScreenWidth } from "../scripts/store";
    import { historyNavigation } from "../scripts/router1";
    import { scrollTo } from "../scripts/commons";
    import {
        idPageAmenagements,
        idPageAmenagementsEnrobes,
        idPageAmenagementsResines,
        idPageAmenagementsPavage,
        idPageAmenagementsContact,
        idPageServices,
        idPageServicesAssainissement,
        idPageServicesBalayage,
        idPageServicesContact,
        namePageServicesAssainissement,
        namePageServicesBalayage,
        namePageServicesContact,
        namePageAmenagementsEnrobes,
        namePageAmenagementsResines,
        namePageAmenagementsPavage,
        namePageAmenagementsContact,
    } from "../scripts/router2";

    function burgerToggle() {
        if (getComputedStyle(document.getElementById("id_burger")).display != "none") {
            storeIsOpenBurger.set(!$storeIsOpenBurger);
        }
    }

    function selectItem(item) {
        if ($storeIsOpenBurger) {
            burgerToggle();
        }
        storeAnchorToLight.set(item);
        if ($storeScreenWidth > 1024) {
            scrollTo(item, true);
        } else {
            setTimeout(() => {
                scrollTo(item, true);
            }, 500);
        }
    }

</script>
  
  
<style lang="scss">

    $color_navigation_bg: $color-bleu-instit;
    $color_navigation: $color-bleu-clair-instit;
    $color_menu: $color-bleu-instit;
    $color_menu_item: $color-bleu-clair-instit;
    $color_menu_item_hover: $color-white;
    $color_menu_item_active: $color-white;

    .burger2 {
        position: fixed;
        top: 0px;
        left: 0px;
        height: $header-height;
        width: 100%;
        cursor: pointer;
        z-index: 1000;
        display: grid;
        grid-template-areas: "logo vide burger";
        grid-template-columns: 80% 1fr 12%;
        transform: translateY(-$header-height);
        transition: transform 0.01s;
        &--open {
            transition-property: transform;
            transition-duration:  1.5s;
            transform: translateY(0);
        }
        &__services {
            background-color: $color-bleu-instit;
        }
        &__amenagements {
            background-color: $color-bordeau-instit;
        }
        &__logo {
            width: auto;
            height: 30px;
            padding: $contener-marge-small 0 0 $contener-marge-small;
        }
        &__burgerenvelop {
            grid-area: burger;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-end;
            padding: 0 $contener-marge-small 0 0;
        }
        &__line {                
            height: 35px;
            width: 35px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 35px;
            &__services {
                background-image: url("../images/burger-services.png");
            }
            &__amenagements {
                background-image: url("../images/burger-amenagements.png");
            }
        }
        &__cross {
            grid-area: burger;
            height: 35px;
            width: 35px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 35px;
            &__services {
                background-image: url("../images/burger-services-cross.png");
            }
            &__amenagements {
                background-image: url("../images/burger-amenagements-cross.png");
            }
        }
    }

    .navigation {
        z-index: 100;
        position: fixed;
        top: 0px;
        left: 0px;
        padding: 75px $contener-marge-small 200% $contener-marge-small;
        width: 100%;
        border-radius: 4px;
        color: $color_white;
        transition: transform;
        transition-delay: 0s;
        transition-duration: 0s;
        transform: translateY(-100%);
        &--open {
            transition: transform;
            transition-delay: 0.5s;
            transition-duration: 1s;
            transform: translateY(0);
        }
        &__slash {
            width: 12px;
            height: 19px;
            padding: 0 0 20px 0;
        }
        &__services {
            background-color: $color-bleu-instit;
            &__logo {
               display: none;
            }
        }
        &__amenagements {
            background-color: $color-bordeau-instit;
            &__logo {
               display: none;
            }
        }
    }

    .menu {
        margin: 20px 40px 20px 40px;
        list-style-type: none;
        &__services {
            &__item {
                padding: 0 0 20px 0;
            }
            &__spacer {
                display: none;
            }
        }
        &__amenagements {
            &__item {
                padding: 0 0 20px 0;
            }
            &__spacer {
                display: none;
            }
        }
    }
    
    @include large {
        .burger2 {
            display: none;
        }

        .navigation {
            z-index: 100;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            padding: 0 0 15px 0;
            max-width: 100%;
            background-color: $color_menu;
            border-radius: 0px;
            color: $color_navigation;
            opacity: 0;
            transition: all;
            transition-duration: 1s;
            transition-delay: 1s;
            width: 100%;
            height: $header-height;
            &__slash {
                display: none;
            }
            &--opendesk {
                transform: translateY(0);
                opacity: 1;
            }
            &__services {
                background-color: $color-bleu-instit;
                &__margin {
                    min-width: 140px;
                    height: $header-height;
                    background-color: $color-bleu-instit;
                }
                &__logo {
                    display: block;
                    height: 40px;
                    padding: 15px 0 0 0;
                    cursor: pointer;
                }
            }
            &__amenagements {
                background-color: $color-bordeau-instit;
                &__margin {
                    min-width: 140px;
                    height: $header-height;
                    background-color: $color-bordeau-instit;
                }
                &__logo {
                    display: block;
                    height: 40px;
                    padding: 15px 0 0 0;
                    cursor: pointer;
                }
            }
            &__center {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }
            &__menus {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }
        }

        .menu__services {
            width: 100%;
            padding: 0;
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            align-items: center;
            margin: 20px 5px 0 5px;
            background-color: $color-bleu-instit;
            &__item {
                padding: 0 4px 20px 4px;
                position: relative;
                white-space: nowrap;
                color: $color-bleu-clair-instit;
                cursor: pointer;
                &--active {
                    color: $color-white;
                }
                &:hover {
                    color: $color-white;
                }
            }
            &__spacer {
                color: $color-bleu-clair-instit;
                padding: 4px 4px 0 4px;
                display: inline;
                white-space: nowrap;
                &__slash2 {
                    width: 12px;
                    height: 19px;
                }
            }
        }

        .menu__amenagements {
            width: 100%;
            padding: 0;
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            align-items: center;
            margin: 20px 5px 0 5px;
            background-color: $color-bordeau-instit;
            &__item {
                padding: 0 4px 20px 4px;
                position: relative;
                white-space: nowrap;
                color: $color-orange-dde;
                cursor: pointer;
                &--active {
                    color: $color-white;
                }
                &:hover {
                    color: $color-white;
                }
            }
            &__spacer {
                color: $color-orange-dde;
                padding: 4px 4px 0 4px;
                display: inline;
                white-space: nowrap;
                &__slash2 {
                    width: 12px;
                    height: 19px;
                }
            }
        }
    }

    @keyframes swap1 {
        from {
            opacity: 1;
            transform: translateY(0);
        }
        to {
            opacity: 0;
            transform: translateY(-100%);
        }
    }

    @keyframes swap {
        from {
            opacity: 0;
            transform: translateY(-100%);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @include extra-large {
    .navigation {
        &__services {
            &__margin {
                min-width: max(140px, calc((100vw - 1200px) / 2));
            }
            &__logo {
                margin: 0 0 0 -7px;
            }
        }
        &__amenagements {
            &__margin {
                min-width: max(140px, calc((100vw - 1200px) / 2));
            }
            &__logo {
                margin: 0 0 0 -7px;
            }
        }
    }
}
</style>

<svelte:window on:popstate|preventDefault={historyNavigation} />

<div id="id_burger" class="burger2 burger2__services" class:burger2--open={$storeDomain == "services"}>
    <img class="burger2__logo burger2__logo__services" src="../images/logo-services.png" alt="logo" on:click={() => selectItem(idPageServices)} on:keydown={() => selectItem(idPageServices)}>        
    <div class="burger2__burgerenvelop">
        <div class="{$storeIsOpenBurger ? 'burger2__cross burger2__cross__services' : 'burger2__line burger2__line__services'}" on:click={() => burgerToggle()} on:keydown={() => burgerToggle()}></div>
    </div>
</div>

<div id="id_burger" class="burger2 burger2__amenagements" class:burger2--open={$storeDomain == "amenagements"}>
    <img class="burger2__logo burger2__logo__amenagements" src="../images/logo-amenagements.png" alt="logo" on:click={() => selectItem(idPageAmenagements)} on:keydown={() => selectItem(idPageAmenagements)}>
    <div class="burger2__burgerenvelop">
        <div class="{$storeIsOpenBurger ? 'burger2__cross burger2__cross__amenagements' : 'burger2__line burger2__line__amenagements'}" on:click={() => burgerToggle()} on:keydown={() => burgerToggle()}></div>
    </div>
</div>

<nav class="navigation navigation__amenagements font-menu" class:navigation--open={$storeIsOpenBurger && $storeDomain == "amenagements"} class:navigation--opendesk={$storeDomain == "amenagements"}>
    <div class="navigation__amenagements__margin"></div>
    <div class="navigation__center">
        <img class="navigation__amenagements__logo" src="../images/logo-amenagements.png" alt="logo" on:click={() => selectItem(idPageAmenagements)} on:keydown={() => selectItem(idPageAmenagements)}>
        <img class="navigation__slash" src="../images/slash-2-amenagements.png" alt="slash-2-amenagements">
        <div class="navigation__menus">
            <div class="menu__amenagements">
                <div class="menu__amenagements__item" class:menu__amenagements__item--active={$storeAnchorToLight == idPageAmenagementsEnrobes} on:click={() => selectItem(idPageAmenagementsEnrobes)} on:keydown={() => selectItem(idPageAmenagementsEnrobes)}>
                    {namePageAmenagementsEnrobes}
                </div>
            </div>
            <div class="menu__amenagements__spacer">
                <img class="menu__amenagements__spacer__slash2" src="../images/slash-2-amenagements.png" alt="slash-2-amenagements">
            </div>
            <div class="menu__amenagements">
                <div class="menu__amenagements__item" class:menu__amenagements__item--active={$storeAnchorToLight == idPageAmenagementsResines} on:click={() => selectItem(idPageAmenagementsResines)} on:keydown={() => selectItem(idPageAmenagementsResines)}>
                    {namePageAmenagementsResines}
                </div>
            </div>
            <div class="menu__amenagements__spacer">
                <img class="menu__amenagements__spacer__slash2" src="../images/slash-2-amenagements.png" alt="slash-2-amenagements">
            </div>
            <div class="menu__amenagements">
                <div class="menu__amenagements__item" class:menu__amenagements__item--active={$storeAnchorToLight == idPageAmenagementsPavage} on:click={() => selectItem(idPageAmenagementsPavage)} on:keydown={() => selectItem(idPageAmenagementsPavage)}>
                    {namePageAmenagementsPavage}
                </div>
            </div>
            <div class="menu__amenagements__spacer">
                <img class="menu__amenagements__spacer__slash2" src="../images/slash-2-amenagements.png" alt="slash-2-amenagements">
            </div>
            <div class="menu__amenagements">
                <div class="menu__amenagements__item" class:menu__amenagements__item--active={$storeAnchorToLight == idPageAmenagementsContact} on:click={() => selectItem(idPageAmenagementsContact)} on:keydown={() => selectItem(idPageAmenagementsContact)}>
                    {namePageAmenagementsContact}
                </div>
            </div>    
        </div>
    
    </div>
    <div class="navigation__amenagements__margin"></div>
</nav>

<nav class="navigation navigation__services font-menu" class:navigation--open={$storeIsOpenBurger && $storeDomain == "services"}  class:navigation--opendesk={$storeDomain == "services"}>
    <div class="navigation__services__margin"></div>
    <div class="navigation__center">
        <img class="navigation__services__logo" src="../images/logo-services.png" alt="logo" on:click={() => selectItem(idPageServices)} on:keydown={() => selectItem(idPageServices)}>
        <img class="navigation__slash" src="../images/slash-2-services.png" alt="slash-2-services">
        <div class="navigation__menus">
            <div class="menu__services">
                <div class="menu__services__item" class:menu__services__item--active={$storeAnchorToLight == idPageServicesAssainissement} on:click={() => selectItem(idPageServicesAssainissement)} on:keydown={() => selectItem(idPageServicesAssainissement)}>
                    {namePageServicesAssainissement}
                </div>
            </div>
            <div class="menu__services__spacer">
                <img class="menu__services__spacer__slash2" src="../images/slash-2-services.png" alt="slash-2-services">
            </div>
            <div class="menu__services">
                <div class="menu__services__item" class:menu__services__item--active={$storeAnchorToLight == idPageServicesBalayage} on:click={() => selectItem(idPageServicesBalayage)} on:keydown={() => selectItem(idPageServicesBalayage)}>
                    {namePageServicesBalayage}
                </div>
            </div>
            <div class="menu__services__spacer">
                <img class="menu__services__spacer__slash2" src="../images/slash-2-services.png" alt="slash-2-services">
            </div>
            <div class="menu__services">
                <div class="menu__services__item" class:menu__services__item--active={$storeAnchorToLight == idPageServicesContact} on:click={() => selectItem(idPageServicesContact)} on:keydown={() => selectItem(idPageServicesContact)}>
                    {namePageServicesContact}
                </div>
            </div>
        </div>
    </div>
    <div class="navigation__services__margin"></div>
</nav>
